import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import image from '@/features/management/manager/assets/empty-state-no-data.svg';

const Graphics = styled.img.attrs({ src: image })``;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 0;
`;

const Heading = styled.h3`
  ${(p) => p.theme.typography.title3};
  color: ${(p) => p.theme.colors.neutral.onBackground};
  margin-bottom: 8px;
`;

const Subheading = styled.span`
  ${(p) => p.theme.typography.body3};
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

type ManagementEmptyStateNoDataProps = {
  heading?: string;
  subheading?: string;
};

export const ManagementEmptyStateNoData = ({ heading, subheading }: ManagementEmptyStateNoDataProps): JSX.Element => {
  const { t } = useTranslation('managerDashboard');

  return (
    <Wrapper>
      <Graphics />
      <Heading>{heading || t('empty-state-no-data-found')}</Heading>
      {subheading && <Subheading>{subheading}</Subheading>}
    </Wrapper>
  );
};
